import React, { useState } from 'react';
import { useProjectStore } from '../../stores/projectStore';
import { Play, Hand, Move, RotateCw, Maximize, MousePointer2, BoxSelect } from 'lucide-react';
import { ThreeScene } from '../scene/ThreeScene';

// Export from separate files
export { CodeEditorPanel } from './CodeEditorPanel';
export { BuildPanel } from './BuildPanel';
export { AIChatPanel } from './AIChatPanel';
export { AssetsPanel } from './AssetsPanel';
export { HierarchyPanel } from './HierarchyPanel';
export { ConsolePanel } from './ConsolePanel';
export { InspectorPanel } from './InspectorPanel';

const SceneToolbar = () => {
  const [activeTool, setActiveTool] = useState('select');
  const [is2D, setIs2D] = useState(false);

  return (
    <div className="scene-toolbar flex items-center justify-between px-2 py-1 bg-[#252526] border-b border-[#333]">
      <div className="flex items-center gap-1">
        <button 
          className={`p-1.5 rounded hover:bg-[#333] ${activeTool === 'hand' ? 'bg-[#375eab] text-white' : 'text-gray-400'}`}
          onClick={() => setActiveTool('hand')}
          title="Hand Tool (Q)"
        >
          <Hand size={14} />
        </button>
        <button 
          className={`p-1.5 rounded hover:bg-[#333] ${activeTool === 'select' ? 'bg-[#375eab] text-white' : 'text-gray-400'}`}
          onClick={() => setActiveTool('select')}
          title="Move Tool (W)"
        >
          <Move size={14} />
        </button>
        <button 
          className={`p-1.5 rounded hover:bg-[#333] ${activeTool === 'rotate' ? 'bg-[#375eab] text-white' : 'text-gray-400'}`}
          onClick={() => setActiveTool('rotate')}
          title="Rotate Tool (E)"
        >
          <RotateCw size={14} />
        </button>
        <button 
          className={`p-1.5 rounded hover:bg-[#333] ${activeTool === 'scale' ? 'bg-[#375eab] text-white' : 'text-gray-400'}`}
          onClick={() => setActiveTool('scale')}
          title="Scale Tool (R)"
        >
          <Maximize size={14} />
        </button>
      </div>

      <div className="flex items-center gap-2">
        <button 
          className={`px-2 py-0.5 text-xs rounded hover:bg-[#333] ${is2D ? 'bg-[#375eab] text-white' : 'text-gray-400'}`}
          onClick={() => setIs2D(!is2D)}
        >
          {is2D ? '2D' : '3D'}
        </button>
        <div className="h-4 w-px bg-[#444]" />
        <div className="flex items-center gap-1 text-gray-400">
          <MousePointer2 size={12} />
          <span className="text-[10px]">Global</span>
        </div>
      </div>
    </div>
  );
};

export function ScenePanel({ className }: { className?: string }) {
  const { currentProject } = useProjectStore();

  return (
    <div className={`scene-panel ${className || ''} flex flex-col h-full bg-[#1e1e1e]`}>
      <div className="panel-header">
        <h3>Scene</h3>
      </div>
      
      <SceneToolbar />

      <div className="panel-content scene-content flex-1 relative overflow-hidden">
        {currentProject ? (
          <ThreeScene />
        ) : (
          <div className="scene-placeholder">
            <div className="placeholder-content">
              <Play size={48} />
              <h3>🎮 Scene Preview</h3>
              <p>Load a project to see the scene</p>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .scene-content {
          padding: 0;
        }
        .scene-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #222;
        }
        .placeholder-content {
          text-align: center;
          color: #666;
        }
        .placeholder-content h3 {
          margin: 16px 0 8px;
          color: #ccc;
        }
        .placeholder-content p {
          margin: 4px 0;
          font-size: 13px;
        }
      `}</style>
    </div>
  );
}